import { Box } from '@bechtel/gds';
import styled from 'styled-components';


export const HeaderStyled = styled(Box).attrs({
    alignItems: { sm: 'center' },
})`
    height: 50px;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    background-color: #fff;
    justify-content: space-between;
    position: relative;
  `;
